"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GlobalTopAreaStyles = require("./GlobalTopAreaStyles");
Object.keys(_GlobalTopAreaStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GlobalTopAreaStyles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GlobalTopAreaStyles[key];
    }
  });
});